import { useLanguage } from '../../modules/i18n'
import Language from '../../app/Language.enum'
import ContainedPage from '../../components/layout/ContainedPage'
import Spinner from '../../components/Spinner'

const MoveReminderPage: React.FC = () => {
  const language = useLanguage() as Language
  const urls = {
    [Language.En]: 'https://go.movingwaldo.ca/MovingWaldo-MoveReminder',
    [Language.Fr]: 'https://go.movingwaldo.ca/MovingWaldo-RappelDéménagement',
  }
  document.location = urls[language] || urls[Language.En]

  return (
    <ContainedPage>
      <Spinner floating />
    </ContainedPage>
  )
}

export default MoveReminderPage
